// extracted by mini-css-extract-plugin
module.exports = {"tile":"tile-module__tile___1nIrD","header":"tile-module__header___2qdRu","body":"tile-module__body___2zmpE","scrolled":"tile-module__scrolled___1XJPR"};